import type { FunctionComponent } from 'react';

import type { BaseProps, ForwardProps } from '../../types';

export interface OptionProps extends BaseProps {
  /** Text content for the Option. */
  children: string;
  /** Value associated with the Option. This value is passed to the Select onChange function. */
  value?: string;
}

const defaultProps: Partial<OptionProps> = {};

const Option: FunctionComponent<OptionProps & ForwardProps> = (props: OptionProps) => {
  const { children, ...restProps } = props;
  return <option {...restProps}>{children}</option>;
};

Option.defaultProps = defaultProps;

export default Option;
